import { useReactiveVar } from '@apollo/client';
import { useEffect } from 'react';

import { userAmsUserIdVar } from '../../../constants';
import useSetUserFromCurrentSession from '../../auth/useSetUserFromCurrentSession/useSetUserFromCurrentSession';
import { syncAnalyticsUserIdentity } from './syncAnalyticsUserIdentity';

const useAnalyticsUserIdentification = (trackingActive: boolean): void => {
  const selectedUserId = useReactiveVar(userAmsUserIdVar);
  const { userInfo } = useSetUserFromCurrentSession();

  useEffect(() => {
    if (!trackingActive) {
      return;
    }

    syncAnalyticsUserIdentity({
      cognitoUserInfo: userInfo,
      amsUserIdVar: selectedUserId,
    });
  }, [trackingActive, selectedUserId, userInfo]);
};

export default useAnalyticsUserIdentification;
